import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FormControl, MenuItem, Select } from "@mui/material";
import Navbar from "../components/Navbar";
import TourManagementSidebar from "../components/tour/TourManagementSidebar";
import InfoCardLightening from "../components/tour/InfoCardLightening";
import { Paths } from "../router/Paths";
import useOnLoadPage from "../hooks/useOnLoadPage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { setPackageData } from "../reducer/tourReducer";
import { usePackage } from "../hooks/usePackage";
import { addActiveTab } from "../reducer/sideBarSlice";
import PhoneNumberInput from "../components/common/PhoneNumberInput";
import { resetTourEdit } from "../reducer/tourEditReducer";

const contactOptions = ["Facebook", "Phone number", "Email"];

const ActivitysuggestedOptions = [
  "People over 70 years",
  "People with altitude sickness",
  "Babies Under 1 year",
  "Children under 10 years",
  "Children under 11 years",
  "Children under 12 years",
  "Children under 13 years",
  "Children under 14 years",
  "Children under 15 years",
  "Children under 16 years",
  "Large Group",
  "Under 18",
  "Pergenat women",
  "visually impaired people",
  "people with vertigo",
  "People without experience",
  "People with epliepsy",
  "vegan",
  "Wheelchair users",
  "People who can't drive manual transmission",
];

const AllowedsuggestedOptions = [
  "Alcohol and drugs",
  "Audio recording",
  "Baby carriages",
  "Baby strollers",
  "Bachelor & party groups",
  "Bags",
  "Bare feet",
  "Bikes",
  "Cooler",
  "Diving",
  "Large Group",
  "Under 18",
  "Pergenat wemon",
];

const MandatorysuggestedOptions = [
  "bag",
  "book",
  "Binoculars",
  "Beach Wear",
  "Bachelor ",
  "cash",
  "camera",
  "Boating licence",
];

const AllowedsuggestedAllowedOptions = [
  "Alcohol and drugs",
  "Audio recording",
  "Baby carriages",
  "bag",
  "book",
  "Binoculars",
  "Beach Wear",
  "Bachelor ",
  "cash",
  "camera",
];

function TourManagementPackageExtraInfoPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { packageData } = useSelector((state: RootState) => state.tour);
  const [activity, setActivity] = useState("");
  const [allowed, setAllowed] = useState("");
  const [mandatory, setMandatory] = useState("");
  const [emergencyType, setEmergencyType] = useState("");
  const [emergencyValue, setEmergencyValue] = useState("");
  const [emergencyPhoneNumber, setEmergencyPhoneNumber] = useState("234-");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<string>("");
  const { PrepackageDataId }: any = useSelector(
    (state: RootState) => state.tour
  );
  const { tourEdit, id } = useSelector((state: RootState) => state.edit);
  const [searchInput, setSearchInput] = useState("");
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [activityShowDropDown, setActivityShowDropDown] = useState(false);
  const [allowedShowDropDown, setAllowedShowDropDown] = useState(false);
  const [mandatoryShowDropDown, setMandatroyShowDropDown] = useState(false);
  const [allowedndropdown, setAllowedndropdown] = useState(false);
  const activitydropdownRef: any = useRef(null);
  const alloweddropdownRef: any = useRef(null);
  const mandatorydropdownRef: any = useRef(null);
  const allowedndropdownRef: any = useRef(null);

  useOnLoadPage({ tabActive: "create" });
  const { createPrePackage } = usePackage();
  const progressref = useRef(9);

  useEffect(() => {
    const handleKeyDown = (event: any) => {
      if (event.keyCode === 13) {
        handleContactAdd();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [emergencyType, emergencyValue]);

  useEffect(() => {
    if (location.state && location.state.packageData) {
      dispatch(setPackageData(location.state.packageData));
    }
  }, [location.state, dispatch]);

  useEffect(() => {
    if (packageData.contactMethod) {
      setEmergencyPhoneNumber(packageData.contactMethod); // Initialize input with packageData value
    }
  }, [packageData.contactMethod]);

  useEffect(() => {
    if (emergencyPhoneNumber && emergencyPhoneNumber !== "234-") {
      dispatch(
        setPackageData({
          contactMethod: emergencyPhoneNumber, // Update contactMethod only when emergencyPhoneNumber changes
        })
      );
    }
  }, [emergencyPhoneNumber, dispatch]);

  const onContinue = () => {
    dispatch(addActiveTab(Paths.tourManagementPackagePhotoUpload));
    navigate(Paths.tourManagementPackagePhotoUpload);
  };

  const handleClickOutsideActivity = (event: any) => {
    if (
      activitydropdownRef.current &&
      !activitydropdownRef.current?.contains(event.target)
    ) {
      setActivityShowDropDown(false);
    }
  };

  const handleClickOutsideAllowed = (event: any) => {
    if (
      alloweddropdownRef.current &&
      !alloweddropdownRef.current?.contains(event.target)
    ) {
      setAllowedShowDropDown(false);
    }
  };

  const handleClickOutsideMandatory = (event: any) => {
    if (
      mandatorydropdownRef.current &&
      !mandatorydropdownRef.current?.contains(event.target)
    ) {
      setMandatroyShowDropDown(false);
    }
  };

  const handleClickOutsideAllowedNew = (event: any) => {
    if (
      allowedndropdownRef.current &&
      !allowedndropdownRef.current?.contains(event.target)
    ) {
      setAllowedndropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideAllowed);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideAllowed);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideActivity);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideActivity);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideMandatory);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideMandatory);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideAllowedNew);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideAllowedNew);
    };
  }, []);

  const onSave = async () => {
    const updatedPackageData = {
      ...packageData,
      _id: PrepackageDataId,
      progress: Number(progressref.current),
    };

    const updatedPackageData2 = {
      ...packageData,
    };

    dispatch(setPackageData(updatedPackageData));
    setLoading(true);

    try {
      if (tourEdit) {
        dispatch(resetTourEdit());
        dispatch(setPackageData(updatedPackageData2));
        navigate(Paths.manageProductDetails.replace(":id", id), {
          state: { fromEdit: true },
        });
        return;
      } else {
        await createPrePackage(updatedPackageData);
      }

      localStorage.setItem("packageData", JSON.stringify(updatedPackageData));
      navigate(Paths.welcome);
    } catch (error) {
      console.error("Error saving package:", error);
    } finally {
      setLoading(false);
    }
  };
  // Unsuitable for

  const handleActivitCheckboxToggle = (option: string) => {
    let data = packageData?.notSuitableFor || [];
    console.log("allactiv", data);
    const updatedItems = data.includes(option)
      ? data.filter((item) => item !== option)
      : [...data, option];

    const unsuitable = updatedItems.length > 0 ? updatedItems : [];

    dispatch(
      setPackageData({
        notSuitableFor: unsuitable,
      })
    );
  };

  const handleAcctivityRemoveItem = (index: number) => {
    let data = packageData?.notSuitableFor
      ? [...packageData?.notSuitableFor]
      : [];
    let filteredData = data.filter((_, idx) => idx !== index);
    dispatch(
      setPackageData({
        notSuitableFor: filteredData,
      })
    );
  };

  const handleAllowedCheckboxToggle = (option: string) => {
    let data = packageData?.prohibitedList || [];
    const updatedItems = data.includes(option)
      ? data.filter((item) => item !== option)
      : [...data, option];

    dispatch(
      setPackageData({
        ...packageData,
        prohibitedList: updatedItems,
      })
    );
  };

  const handleAllowedRemoveItem = (index: number) => {
    let data = packageData?.prohibitedList
      ? [...packageData?.prohibitedList]
      : [];
    let filteredData = data.filter((_, idx) => idx !== index);
    dispatch(
      setPackageData({
        prohibitedList: filteredData,
      })
    );
  };

  const handleAllowedNewCheckboxToggle = (option: string) => {
    let data = packageData?.allowedList || [];
    const updatedItems = data.includes(option)
      ? data.filter((item) => item !== option)
      : [...data, option];

    dispatch(
      setPackageData({
        ...packageData,
        allowedList: updatedItems,
      })
    );
  };

  const handleAllowedNewRemoveItem = (index: number) => {
    let data = packageData?.allowedList ? [...packageData?.allowedList] : [];
    let filteredData = data.filter((_, idx) => idx !== index);
    dispatch(
      setPackageData({
        allowedList: filteredData,
      })
    );
  };

  const handlemandtoryCheckboxToggle = (option: string) => {
    let data = packageData?.mandatoryItems || [];
    const updatedItems = data.includes(option)
      ? data.filter((item) => item !== option)
      : [...data, option];
    const mandatoryItems = updatedItems.length > 0 ? updatedItems : [];
    dispatch(
      setPackageData({
        ...packageData,
        mandatoryItems: mandatoryItems,
      })
    );
  };

  const handlemandatoryRemoveItem = (index: number) => {
    let data = packageData?.mandatoryItems
      ? [...packageData?.mandatoryItems]
      : [];
    let filteredData = data.filter((_, idx) => idx !== index);
    dispatch(
      setPackageData({
        mandatoryItems: filteredData,
      })
    );
  };

  const validateEmergencyContact = (type: string, value: any) => {
    switch (type) {
      case "Phone number":
        // Check for valid phone number (10-15 digits)
        return /^\d{10,15}$/.test(value);

      case "Email":
        // Check for valid email
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

      case "Facebook":
        // Check for valid Facebook profile URL
        return /^https?:\/\/(www\.)?facebook\.com\/[a-zA-Z0-9.]{5,}$/.test(
          value
        );

      default:
        return false; // Invalid type
    }
  };

  // Contact information

  const handleContactAdd = () => {
    if (!emergencyPhoneNumber || emergencyPhoneNumber === "234-") {
      setErrors("Please provide a valid phone number.");
      return;
    }

    dispatch(
      setPackageData({
        contactMethod: emergencyPhoneNumber, // Store as a string
      })
    );

    setErrors("");
  };

  console.log("packagedata", packageData);

  const handleBack = () => {
    navigate(Paths.tourManagementPackageTransportation);
  };

  return (
    <div className={Classname.container}>
      <Navbar />
      <div className={Classname.content}>
        <TourManagementSidebar selected={10} />

        <div className={Classname.detail}>
          <span className={Classname.title}>
            Before booking with Intraverse
          </span>

          <div>
            {/* Search input field */}
            <div className="space-y-4">
              <span className={Classname.title}>
                Who is this activity not suitable for?{" "}
                <span className={Classname.titleOptional}>(optional)</span>
              </span>
              <p className={Classname.description}>
                Add the types of travelers who should not join this activity,
                like under 18s or pregnant women. This information appears on
                the activity details page.
              </p>

              {/* Search input field */}
              <div className="relative">
                <input
                  type="text"
                  value={searchInput}
                  onChange={(e) => {
                    setSearchInput(e.target.value);
                    setActivityShowDropDown(true);
                  }}
                  onFocus={() => setActivityShowDropDown(true)}
                  placeholder="Search for items"
                  className={` ${Classname.input} w-full`}
                />

                {/* Dropdown options with checkboxes */}
                {activityShowDropDown && (
                  <div
                    ref={activitydropdownRef}
                    className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-md z-10 max-h-60 overflow-y-scroll"
                  >
                    {ActivitysuggestedOptions.filter((option) =>
                      option.toLowerCase().includes(searchInput.toLowerCase())
                    ).map((option, index) => (
                      <div
                        key={index}
                        className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
                      >
                        <input
                          type="checkbox"
                          id={`option-${index}`}
                          className="mr-2 cursor-pointer"
                          checked={packageData?.notSuitableFor?.includes(
                            option
                          )}
                          onChange={() => handleActivitCheckboxToggle(option)}
                        />
                        <label
                          htmlFor={`option-${index}`}
                          className="cursor-pointer capitalize"
                        >
                          {option}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Selected items */}
              <div className="flex flex-wrap gap-2">
                {packageData?.notSuitableFor?.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-center px-3 py-1 text-sm bg-gray-100 border border-gray-300 rounded-full"
                  >
                    <span>{item}</span>
                    <button
                      onClick={() => handleAcctivityRemoveItem(index)}
                      className="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={2}
                        stroke="currentColor"
                        className="w-4 h-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                ))}
              </div>
            </div>

            {/* Selected items */}
          </div>

          {/* allowed items */}

          <>
            <span className={Classname.title}>
              What’s allowed?{" "}
              <span className={Classname.titleOptional}>(optional)</span>
            </span>
            <p className={Classname.description}>
              List any object, clothing, or action that’s allowed on your
              activity, such as camera. This information appears on the activity
              details page & voucher.
            </p>
            <div className="relative">
              <input
                type="text"
                value={searchInput}
                onChange={(e) => {
                  setSearchInput(e.target.value);
                  setAllowedndropdown(true);
                }}
                onFocus={() => setAllowedndropdown(true)}
                placeholder="Search for items"
                className={` ${Classname.input} w-full`}
              />

              {/* Dropdown options with checkboxes */}
              {allowedndropdown && (
                <div
                  ref={allowedndropdownRef}
                  className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-md z-10 max-h-60 overflow-y-scroll"
                >
                  {AllowedsuggestedAllowedOptions.filter((option) =>
                    option.toLowerCase().includes(searchInput.toLowerCase())
                  ).map((option, index) => (
                    <div
                      key={index}
                      className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
                    >
                      <input
                        type="checkbox"
                        id={`option-${index}`}
                        className="mr-2 cursor-pointer"
                        checked={packageData?.allowedList?.includes(option)}
                        onChange={() => handleAllowedNewCheckboxToggle(option)}
                      />
                      <label
                        htmlFor={`option-${index}`}
                        className="cursor-pointer capitalize"
                      >
                        {option}
                      </label>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Selected items */}
            <div className="flex flex-wrap gap-2 mt-5">
              {packageData?.allowedList?.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center px-3 py-1 text-sm bg-gray-100 border border-gray-300 rounded-full"
                >
                  <span>{item}</span>
                  <button
                    onClick={() => handleAllowedNewRemoveItem(index)}
                    className="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      className="w-4 h-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              ))}
            </div>
          </>

          <>
            <span className={Classname.title}>
              What’s not allowed?{" "}
              <span className={Classname.titleOptional}>(optional)</span>
            </span>
            <p className={Classname.description}>
              List any object, clothing, or action that’s not allowed on your
              activity, such as sleeveless shirts. This information appears on
              the activity details page & voucher.
            </p>
            <div className="relative">
              <input
                type="text"
                value={searchInput}
                onChange={(e) => {
                  setSearchInput(e.target.value);
                  setAllowedShowDropDown(true);
                }}
                onFocus={() => setAllowedShowDropDown(true)}
                placeholder="Search for items"
                className={` ${Classname.input} w-full`}
              />

              {/* Dropdown options with checkboxes */}
              {allowedShowDropDown && (
                <div
                  ref={alloweddropdownRef}
                  className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-md z-10 max-h-60 overflow-y-scroll"
                >
                  {AllowedsuggestedOptions.filter((option) =>
                    option.toLowerCase().includes(searchInput.toLowerCase())
                  ).map((option, index) => (
                    <div
                      key={index}
                      className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
                    >
                      <input
                        type="checkbox"
                        id={`option-${index}`}
                        className="mr-2 cursor-pointer"
                        checked={packageData?.prohibitedList?.includes(option)}
                        onChange={() => handleAllowedCheckboxToggle(option)}
                      />
                      <label
                        htmlFor={`option-${index}`}
                        className="cursor-pointer capitalize"
                      >
                        {option}
                      </label>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Selected items */}
            <div className="flex flex-wrap gap-2 mt-5">
              {packageData?.prohibitedList?.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center px-3 py-1 text-sm bg-gray-100 border border-gray-300 rounded-full"
                >
                  <span>{item}</span>
                  <button
                    onClick={() => handleAllowedRemoveItem(index)}
                    className="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      className="w-4 h-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              ))}
            </div>
          </>

          {/* Mandatory Items */}

          <>
            <span className={Classname.title}>
              What mandatory items must the customer bring with them?{" "}
              <span className={Classname.titleOptional}>(optional)</span>
            </span>
            <p className={Classname.description}>
              Such as a towel for a boat tour, or comfortable shoes for a hike.
              This information appears on the activity details page & voucher.
            </p>
            <div className="relative">
              <input
                type="text"
                value={searchInput}
                onChange={(e) => {
                  setSearchInput(e.target.value);
                  setMandatroyShowDropDown(true); // Show dropdown on typing
                }}
                onFocus={() => setMandatroyShowDropDown(true)} // Show dropdown on focus
                placeholder="Search for items"
                className={` ${Classname.input} w-full`}
              />

              {/* Dropdown options with checkboxes */}
              {mandatoryShowDropDown && (
                <div
                  ref={mandatorydropdownRef}
                  className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-md z-10 max-h-60 overflow-y-scroll"
                >
                  {MandatorysuggestedOptions.filter((option) =>
                    option.toLowerCase().includes(searchInput.toLowerCase())
                  ).map((option, index) => (
                    <div
                      key={index}
                      className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
                    >
                      <input
                        type="checkbox"
                        id={`option-${index}`}
                        className="mr-2 cursor-pointer"
                        checked={packageData?.mandatoryItems?.includes(option)}
                        onChange={() => handlemandtoryCheckboxToggle(option)}
                      />
                      <label
                        htmlFor={`option-${index}`}
                        className="cursor-pointer capitalize"
                      >
                        {option}
                      </label>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Selected items */}

            <div className="flex flex-wrap gap-2 mt-5 ">
              {packageData?.mandatoryItems?.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center px-3 py-1 text-sm bg-gray-100 border border-gray-300 rounded-full"
                >
                  <span>{item}</span>
                  <button
                    onClick={() => handlemandatoryRemoveItem(index)}
                    className="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      className="w-4 h-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              ))}
            </div>
          </>

          <span className={Classname.title}>Before the activity</span>

          {/* Contact */}

          <>
            <span className={Classname.title}>
              How can customers contact you in case of an emergency?{" "}
              <span className={Classname.titleOptional}>(optional)</span>
            </span>
            <p className={Classname.description}>
              This information appears on the voucher.
            </p>
            <div className="flex flex-wrap gap-3 items-center">
              <PhoneNumberInput
                value={emergencyPhoneNumber} // Ensure input reflects the state
                onChange={(value) => setEmergencyPhoneNumber(value)} // Update state on change
                className="!w-full !border-gray-400"
              />
            </div>
            {errors && <div className="text-red-500 text-sm">{errors}</div>}
          </>

          <span className={Classname.title}>
            What else do customers need to know before your activity?{" "}
            <span className={Classname.titleOptional}>(optional)</span>
          </span>
          <p className={Classname.description}>
            Add any remaining information that customers must know before they
            book. This infoProvide any other logistical information that hasn't
            been covered elsewhere. This appears on the voucher.rmation appears
            on the activity details page.
          </p>
          <textarea
            name=""
            id=""
            cols={30}
            rows={10}
            className={Classname.textarea}
            placeholder="Leave it blank if it does not apply to your package"
            value={packageData?.informationForCustomers}
            onChange={(e) => {
              dispatch(
                setPackageData({
                  informationForCustomers: e.target.value,
                })
              );
            }}
          />

          <InfoCardLightening description="Make sure the customer has any remaining information they need to enjoy the activity fully, or the next steps. Use bullet points." />

          <div className="flex justify-between items-centers mt-10">
            <button className={Classname.saveButton2} onClick={handleBack}>
              Back
            </button>
            <div className={Classname.buttonsContainer}>
              <button
                className={Classname.saveButton}
                onClick={onSave}
                disabled={loading}
              >
                {loading ? "Please Wait..." : "Save and exit"}
              </button>
              {!tourEdit && (
                <button
                  className={Classname.continueButton}
                  onClick={onContinue}
                >
                  Continue
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TourManagementPackageExtraInfoPage;

const Classname = {
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 max-lg:px-4",
  detail: "flex flex-col py-10 lg:px-6 w-full",
  title: "font-bold text-lg mt-6 mb-2",
  titleOptional: "text-sm text-gray-500 font-normal",
  input:
    "flex flex-1 h-14 border border-gray-400 rounded-md px-4 mt-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
  // input: " w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
  addButton:
    "bg-primary h-14 px-4 rounded-lg flex items-center justify-center text-white font-bold mt-2",
  textarea:
    "flex w-full h-44 py-4 border border-gray-400 rounded-md px-4 mt-2 mb-6",
  description: "flex text-base mb-4",
  buttonsContainer: "flex max-lg:justify-between gap-3 max-lg:w-full",
  highlightButton:
    "font-bold flex items-center gap-2 cursor-pointer text-primary1 py-4",
  saveButton:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  saveButton2:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md max-lg:hidden",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
  listContainer: "flex flex-wrap gap-4 mt-4",
  listItem:
    "text-primary1 text-sm border border-primary1 px-3 py-1 rounded-md cursor-pointer flex items-center gap-2",
};
